import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  disconnectCalendar,
  listUserCalendars,
  startCalendarConnect,
  syncCalendar,
} from '../lib/userCalendarsApi';

export function useUserCalendars(userId: string | undefined) {
  return useQuery({
    queryKey: ['userCalendars', userId],
    queryFn: () => listUserCalendars(userId as string),
    enabled: Boolean(userId),
  });
}

// Starts the OAuth flow: requests the consent URL then hard-redirects the
// browser to Google. The callback returns the user to /people/:id?calendar=...
export function useConnectCalendar(userId: string) {
  return useMutation({
    mutationFn: (label?: string) => startCalendarConnect(userId, label),
    onSuccess: ({ authUrl }) => {
      window.location.href = authUrl;
    },
  });
}

export function useDisconnectCalendar(userId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (calendarId: string) => disconnectCalendar(userId, calendarId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['userCalendars', userId] });
    },
  });
}

export function useSyncCalendar(userId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (calendarId: string) => syncCalendar(userId, calendarId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['userCalendars', userId] });
    },
  });
}
